var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotSelectedWorkspace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "320px",
    height: "320px",
    viewBox: "0 0 320 320",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Lv1/Illust/notSelectedWorkspace") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075E3",
    stopOpacity: 0.5,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075E3",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BE8A",
    stopOpacity: 0.5,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BE8A",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lv1/Illust/notSelectedWorkspace",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.455998,86.3999636 C82.3681848,108.956423 50.5079602,150.464657 64.2173275,194.4956 C77.9266948,238.526544 121.672452,263.586185 152.212034,240.152105 C182.751617,216.718026 243.273117,252.063645 256.792528,184.241287 C263.900873,148.581098 247.324476,97.64673 216.879387,80.2081594 C189.420755,64.4801938 157.610923,70.4603029 126.455998,86.3999636 Z",
    id: "Path-11",
    fill: "#E6F2FA",
    transform: "translate(159.713692, 160.057941) rotate(200.000000) translate(-159.713692, -160.057941) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(108.000000, 118.000000)",
    fill: "#FFFFFF",
    stroke: "#E9ECEF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.5,
    y: 0.5,
    width: 101,
    height: 88,
    rx: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(123.000000, 172.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E9ECEF",
    x: 0,
    y: 0,
    width: 30,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,0 L18,0 L18,0 L18,4 L1,4 C0.44771525,4 6.76353751e-17,3.55228475 0,3 L0,1 C-6.76353751e-17,0.44771525 0.44771525,1.01453063e-16 1,0 Z",
    id: "Rectangle",
    fill: "#0075E3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(165.000000, 172.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E9ECEF",
    x: 0,
    y: 0,
    width: 30,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,0 L25,0 L25,0 L25,4 L1,4 C0.44771525,4 6.76353751e-17,3.55228475 0,3 L0,1 C-6.76353751e-17,0.44771525 0.44771525,1.01453063e-16 1,0 Z",
    id: "Rectangle",
    fill: "#0075E3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80,172 C80,176.334914 83.4478378,179.864543 87.7508207,179.996193 L88,180 C83.6650857,180 80.1354571,183.447838 80.0038068,187.750821 L80,188 C80,183.581722 76.418278,180 72,180 C76.418278,180 80,176.418278 80,172 Z",
    id: "Combined-Shape",
    fill: "#0075E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223,135 C223,139.334914 226.447838,142.864543 230.750821,142.996193 L231,143 C226.665086,143 223.135457,146.447838 223.003807,150.750821 L223,151 C223,146.581722 219.418278,143 215,143 C219.418278,143 223,139.418278 223,135 Z",
    id: "Combined-Shape",
    fill: "#0075E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,81 C159,84.7854517 162.004783,87.8690987 165.75935,87.995941 L166,88 C162.214548,88 159.130901,91.0047834 159.004059,94.7593502 L159,95 C159,91.1340068 155.865993,88 152,88 C155.865993,88 159,84.8659932 159,81 Z",
    id: "Combined-Shape",
    fill: "#98C3EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,219 C106,222.785452 109.004783,225.869099 112.75935,225.995941 L113,226 C109.214548,226 106.130901,229.004783 106.004059,232.75935 L106,233 C106,229.134007 102.865993,226 99,226 C102.865993,226 106,222.865993 106,219 Z",
    id: "Combined-Shape",
    fill: "#98C3EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,122 C85,124.688755 87.1223067,126.881818 89.7831104,126.99538 L90,127 C87.3112453,127 85.1181819,129.122307 85.0046195,131.78311 L85,132 C85,129.238576 82.7614237,127 80,127 C82.7614237,127 85,124.761424 85,122 Z",
    id: "Combined-Shape",
    fill: "#C8E1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,195 C231,197.688755 233.122307,199.881818 235.78311,199.99538 L236,200 C233.311245,200 231.118182,202.122307 231.00462,204.78311 L231,205 C231,202.238576 228.761424,200 226,200 C228.761424,200 231,197.761424 231,195 Z",
    id: "Combined-Shape",
    fill: "#C8E1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,95 C226,97.6887547 228.122307,99.8818181 230.78311,99.9953805 L231,100 C228.311245,100 226.118182,102.122307 226.00462,104.78311 L226,105 C226,102.238576 223.761424,100 221,100 C223.761424,100 226,97.7614237 226,95 Z",
    id: "Combined-Shape",
    fill: "#C8E1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,71 C95,73.6887547 97.1223067,75.8818181 99.7831104,75.9953805 L100,76 C97.3112453,76 95.1181819,78.1223067 95.0046195,80.7831104 L95,81 C95,78.2385763 92.7614237,76 90,76 C92.7614237,76 95,73.7614237 95,71 Z",
    id: "Combined-Shape",
    fill: "#C8E1F0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E6F2FA",
    x: 92.5,
    y: 192,
    width: 134,
    height: 15
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(102.000000, 200.000000)",
    fill: "#A5ADB5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,0 L58,0 C59.1045695,-2.02906125e-16 60,0.8954305 60,2 C60,3.1045695 59.1045695,4 58,4 L2,4 C0.8954305,4 1.3527075e-16,3.1045695 0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 66,
    y: 0,
    width: 10,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 89,
    y: 0,
    width: 28,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 80,
    y: 0,
    width: 5,
    height: 4,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(122.000000, 132.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-9",
    stroke: "#00BE8A",
    strokeLinecap: "round",
    points: "0 31 46.143366 31 57.4487979 19.3459459 69 17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,31 L16.9396353,27.6933255 L33.6118027,26.4111455 L50.1948141,26.4111455 L66.9561374,26.4111455 L77,25",
    id: "Path-2",
    strokeOpacity: 0.7,
    stroke: "#00BE8A",
    strokeLinecap: "round",
    strokeDasharray: 4
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    stroke: "#0075E3",
    strokeLinecap: "round",
    points: "0 31 11.4794275 4.96756757 23.0822898 4.96756757 34.5617174 17.9837838 46.1645796 3 57.3971377 3 69 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,31 L16.5125784,20.9480198 L33.113934,20.9480198 L49.7152897,20.9480198 L66.4054226,0 L75,0",
    id: "Path",
    strokeOpacity: 0.4,
    stroke: "#0075E3",
    strokeLinecap: "round",
    strokeDasharray: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    fill: "url(#linearGradient-1)",
    points: "0 31 11.4794275 4.96756757 23.0822898 4.96756757 34.5617174 17.9837838 46.1645796 3 57.3971377 3 69 3 69 31"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-9",
    fill: "url(#linearGradient-2)",
    points: "0 31 46.143366 31 57.4487979 19.3459459 69 17 69 31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(218.000000, 163.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-7",
    fill: "#251F20",
    cx: 12,
    cy: 3,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-8",
    fill: "#251F20",
    cx: 24,
    cy: 3,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-10",
    fill: "#F8A9BC",
    cx: 4,
    cy: 7,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-10",
    fill: "#F8A9BC",
    cx: 32,
    cy: 7,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2873909,8.49896135 C20.8787656,7.86395443 21.870786,7.83060186 22.5031306,8.42446629 C23.1354752,9.01833072 23.1686879,10.0145278 22.5773133,10.6495347 C20.9944068,12.3492299 19.2985241,13 17.5,13 C15.7014759,13 14.0055932,12.3492299 12.4226867,10.6495347 C11.8313121,10.0145278 11.8645248,9.01833072 12.4968694,8.42446629 C13.129214,7.83060186 14.1212344,7.86395443 14.7126091,8.49896135 C15.7512707,9.61425659 16.676956,9.85151499 17.5,9.85151499 C18.323044,9.85151499 19.2487293,9.61425659 20.2873909,8.49896135 Z",
    id: "Line",
    fill: "#251F20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E9ECEF",
    x: 108,
    y: 125,
    width: 102,
    height: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9ECEF",
    cx: 114,
    cy: 122,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9ECEF",
    cx: 119,
    cy: 122,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E9ECEF",
    cx: 124,
    cy: 122,
    r: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    id: "%",
    fontFamily: "AvenirNext-Bold, Avenir Next",
    fontSize: 8,
    fontWeight: "bold",
    fill: "#A5ADB5"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 134.356,
    y: 185
  }, "%")), /*#__PURE__*/React.createElement("text", {
    id: "%",
    fontFamily: "AvenirNext-Bold, Avenir Next",
    fontSize: 8,
    fontWeight: "bold",
    fill: "#A5ADB5"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 176.356,
    y: 185
  }, "%")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotSelectedWorkspace);
export default __webpack_public_path__ + "static/media/notSelectedWorkspace.2991374515f0fabefc3548b65ba4b82e.svg";
export { ForwardRef as ReactComponent };